import EventBusV3 from './eventBus'
import { SHOW_UBB_UPGRADE_PLAN_MODAL, SHOW_UPGRADE_PLAN_MODAL } from './eventContract'

export const ubbUserHelper = {
  getUserPermissionsForTier(tierName, user) {
    if (!tierName || !user?.has_usage_based_billing) return null
    const { permissions } = user.usage_based_billing
    const result = []
    Object.keys(permissions).forEach(key => {
      if (permissions[key].includes(tierName)) {
        result.push(key)
      }
    })
    return result
  },

  hasPermissionInNextTier(permission, user) {
    if (!user?.has_usage_based_billing) return false

    const currentTier = this.getCurrentTierName(user)
    if (!currentTier) return false
    const nextTier = this.getTierNameForPermission(permission, user)
    return nextTier && nextTier !== currentTier
  },

  showModalForPermission(permission, canClose = true) {
    EventBusV3.emit(SHOW_UBB_UPGRADE_PLAN_MODAL, { canClose, permission })
  },

  showUpgradePlanModal(permission, canClose = true) {
    EventBusV3.emit(SHOW_UPGRADE_PLAN_MODAL, { canClose, permission })
  },

  getCurrentTierName(user) {
    if (!user?.has_usage_based_billing) return null
    const { current_tier: { name } } = user.usage_based_billing
    return name
  },

  getTierNameForPermission(permission, user) {
    if (!user?.has_usage_based_billing) return null
    const currentTier = this.getCurrentTierName(user)
    if (!currentTier) return null
    const tiersForPermission = user?.usage_based_billing?.permissions[permission] || []
    if (!tiersForPermission || tiersForPermission.includes(currentTier)) return null
    return tiersForPermission[0]
  },

  getNextTierName(user) {
    if (!user?.has_usage_based_billing) return null
    const currentTier = this.getCurrentTierName(user)
    const tiers = user?.usage_based_billing?.tiers || []
    const currentIndex = tiers.findIndex(t => t.name === currentTier)
    if (currentIndex === -1 || currentIndex >= tiers.length - 1) return null
    return tiers[currentIndex + 1]?.name
  },
}
